export const generalPaymentError = {
  NotSelectedPaymentProvider: '30006',
};

export const przelewy24PaymentError = {
  NotAcceptedProviderRules: '30007',
  IncorrectDataCreditCardForm: '30008',
};
